import { gql } from "@apollo/client";

// 获取客户定价方案应用详情
export const GET_CLIENT_PRICING_SCHEME_APPLY_DETAIL = gql`
  query GetClientPricingSchemeApplyDetail($clientId: Long!, $pricingSchemeId: Long!) {
    getClientPricingSchemeApplyDetail(clientId: $clientId, pricingSchemeId: $pricingSchemeId) {
      pricingSchemeId
      clientId
      bindDimension
      bindValueDesc
      bindValues
      effectiveTime
      timezone
      status
      message
      messageKey
    }
  }
`;

// 类型定义
export interface ClientPricingApplyDetail {
  pricingSchemeId: number;
  clientId: number;
  bindDimension: string;
  bindValueDesc: string;
  bindValues: string[];
  effectiveTime: string;
  timezone: string;
  status: number;
  message?: string | null;
  messageKey?: string | null;
}

export interface ClientPricingApplyDetailResponse {
  getClientPricingSchemeApplyDetail: ClientPricingApplyDetail | null;
}

